/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PromotionPricingResponseDTO interface.
 */
export function instanceOfPromotionPricingResponseDTO(value) {
    return true;
}
export function PromotionPricingResponseDTOFromJSON(json) {
    return PromotionPricingResponseDTOFromJSONTyped(json, false);
}
export function PromotionPricingResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'applyPromotion': json['applyPromotion'] == null ? undefined : json['applyPromotion'],
        'catalogShare': json['catalogShare'] == null ? undefined : json['catalogShare'],
    };
}
export function PromotionPricingResponseDTOToJSON(json) {
    return PromotionPricingResponseDTOToJSONTyped(json, false);
}
export function PromotionPricingResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'applyPromotion': value['applyPromotion'],
        'catalogShare': value['catalogShare'],
    };
}
